import { Grid, Typography, Icon, Tooltip } from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';


export default function DirectoryButton({ onClick, directoryName, containerStyle }) {

    const gridStyle = {
        display: 'flex',
        // justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 5,
        ...(containerStyle || {})
    }

    return (
        <Grid item xs={3} style={{ ...gridStyle }}>
            <Icon onClick={onClick} style={{width: '4rem', height: '4rem'}}>
                <FolderIcon fontSize="large" style={{ color: "#686868", cursor: 'pointer', fontSize: '4rem' }} />
            </Icon>
            <Tooltip title={directoryName}>
                <Typography onClick={onClick} style={{ cursor: 'pointer' }} variant="caption" align="center">
                    {directoryName}
                </Typography>
            </Tooltip>

        </Grid>
    )
}